import React from 'react'
import { Carousel, Card } from 'react-bootstrap'

export default function ProjectCarousel() {
    return (
        <Carousel className="d-flex justify-content-center align-items-center">
            <Carousel.Item interval={3000} className="carouselitem" pause="hover">
                <Card.Img variant="top" src="./img/tictactoe.png" className="carouselimg" />
                <Card.Body className="border border-primary">
                    <Card.Title className="text-primary fw-bold text-center">Tic-Tac-Toe</Card.Title>
                    <Card.Text className="text-primary text-center">
                        Classic Tic-Tac-Toe game using OOP and MVC. Styled with bootstrap.
                            </Card.Text>
                </Card.Body>
            </Carousel.Item>
            <Carousel.Item interval={3000} className="carouselitem" pause="hover">
                <Card.Img variant="top" src="./img/todo.png" className="carouselimg" />
                <Card.Body className="border border-primary">
                    <Card.Title className="text-primary fw-bold text-center">To-Do List</Card.Title>
                    <Card.Text className="text-primary text-center">
                        A to-do list page made using react and local storage. Styled with bootstrap.
                            </Card.Text>
                </Card.Body>
            </Carousel.Item>
            <Carousel.Item interval={3000} className="carouselitem" pause="hover">
                <Card.Img variant="top" src="./img/mindreader.png" className="carouselimg" />
                <Card.Body className="border border-primary">
                    <Card.Title className="text-primary fw-bold text-center">Mind Reader</Card.Title>
                    <Card.Text className="text-primary text-center">
                        Mind Reader game. A project with a focus on state. Styled using Bootstrap
                            </Card.Text>
                </Card.Body>
            </Carousel.Item>
        </Carousel>
    )
}
